import { render, staticRenderFns } from "./riskkayitformurize.vue?vue&type=template&id=8a9174f8"
import script from "./riskkayitformurize.vue?vue&type=script&lang=js"
export * from "./riskkayitformurize.vue?vue&type=script&lang=js"
import style0 from "./riskkayitformurize.vue?vue&type=style&index=0&id=8a9174f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports